import { Component } from '@angular/core';
import { CallcardComponentCard } from '../callcard-component-card';

@Component({
  selector: 'app-callcard-cnotes-card',
  templateUrl: './callcard-cnotes-card.component.html',
  styleUrls: ['./callcard-cnotes-card.component.scss']
})
export class CallcardCnotesCardComponent extends CallcardComponentCard {}
